import React, { Component } from "react";
import "./NoteModal.scss";
import NoteModalService from "./NoteModal.service";

export default class NoteModal extends Component {
    state = {
        bookmark: undefined,
        newnote: '',
        success: false,
        isLoading: false,
    };

    onNewNoteValue = (e) => {
        this.setState({
            newnote: e.target.value,
        }); 
    }

    deleteNote = () => {
        NoteModalService.deleteNote(
            this.props.bookmark.id, 
            this.props.userInfo.username,
            this.props.userInfo.token
        )
        .then(() => {
            this.props.bookmark.note = '';
            this.setState({
                success: true,
                newnote: '',
            });
            setTimeout(() => {
                this.props.close();
            }, 2500);
        })
        .catch(error => {
            this.props.alert({
                theme: "error",
                message: error.message,
            });
        })
    }

    editNote = () => {
        this.setState({
            newnote: this.props.bookmark.note
        });
        this.props.bookmark.note = '';
    }


    saveNote = () => {
        this.setState({
            isLoading: true,
        });
        NoteModalService.createNote(
            this.props.bookmark.id, 
            this.state.newnote, 
            this.props.userInfo.username,
            this.props.userInfo.token
        )
        .then(() => {
            this.props.bookmark.note = this.state.newnote;
            // this.reloadButton();
            this.setState({
                success: true,
                isLoading: false,
            });
            setTimeout(() => {
                this.props.close();
            }, 2500);
        })
        .catch(error => {
            this.props.alert({
                theme: "error",
                message: error.message,
            });
        })


    }


    render() {
        return (
        <div className="modal-thing">
            <div className="p-4">
                <h5 className="modal-title" >{this.props.bookmark.title}</h5>
                { this.props.bookmark.note ?
                    <>  
                        <p className="note">{this.props.bookmark.note}</p>
                        <button 
                            className="btn btn btn-link"
                            onClick={this.editNote}
                        >
                            Edit
                        </button>
                        <button 
                            className="btn btn btn-link"
                            onClick={this.deleteNote}>
                            Delete
                        </button>
                    </>
                    :
                    
                    <>
                        <textarea
                            className="w-100 input-nlp custom-input"
                            placeholder="Enter note here"
                            value={this.state.newnote}
                            maxLength={250}
                            rows={5}
                            onChange={this.onNewNoteValue}
                            disabled={this.state.isLoading}
                        />
                        {this.state.isLoading ? (
                            <div
                            id="btn-login-spinner"
                            className="spinner-border spinner-border-sm text-light"
                            role="status"
                            >
                            <span className="sr-only">Loading...</span>
                            </div>
                        ) :
                        <button 
                            className="btn btn-primary btn-save"
                            onClick={this.saveNote}>
                            Save Note
                        </button>
                        }
                    </>

                    
                   
                   

                }
                
            </div>
        </div>
        );
    }
}